export default __webpack_public_path__ + "assets/images/e871dedc5b36e33e0cdf70ae5b141a1f.png";